<template>
    <div class="field-list-container my-5 p-4 border rounded shadow-sm bg-light">
      
      <question-display :question="question"></question-display>
      
      
      <div v-for="(fieldSet, index) in fieldList" :key="index" class="field-set mb-4 row">
        <div class="form-group mb-3" v-for="field in question.fields" :key="field.key_name">
          <label v-if="field.display_label">{{ field.field_name }}</label>
          
          
         
            <div class="col-md-12 mt-1"  v-if="field.type === 'textarea'">
              <textarea 
               
                v-model="fieldSet[field.key_name]"
                class="form-control mb-3"
              ></textarea>
            </div>
          
            <div class="col-md-6 mt-1"  v-if="field.type === 'dropdown'" >
              <select 
               
                v-model="fieldSet[field.key_name]" 
                class="form-control form-select"
              >
                <option value="" disabled>Select an option</option>
                <option v-for="option in dropdownOptions" :key="option.value" :value="option.value">
                  {{ option.name }}
                </option>
              </select>
            </div>
            <div class="col-md-6 mt-1"  v-if="field.type === 'number'" >
              <input
                type="number" 
                v-model="fieldSet[field.key_name]" 
                class="form-control"
              />
            </div>
            
           
          <div v-if="field.type === 'radio'" class="form-check">
            <div v-for="option in field.options" :key="option">
              <input 
                type="radio" 
                :value="option" 
                v-model="fieldSet[field.key_name]" 
                class="form-check-input"
              />
              <label class="form-check-label">{{ option }}</label>
            </div>
          </div>
  
  
  
        </div>
        <button @click="removeFieldSet(index)" class="btn btn-danger mb-3"><i class="fa fa-trash"></i></button>
      </div>
  
  
      
      <button @click="addFieldSet" class="btn btn-primary mt-3">Add</button>
      <small v-if="showValidation && required && !fieldList.length" class="text-danger">This field is required.</small>
    </div>
  </template>
  
  <script>
  import dropdownValues from "@/assets/data/dropdown-values/dropdown.json";
  import surveyService from '@/services/surveyService'; // Import the survey service
  import QuestionDisplay from '../utils/QuestionDisplay.vue';

  export default {
    components: {
        QuestionDisplay
    },
    props: {
      question: Object,
      required: Boolean,
      showValidation: Boolean // Add showValidation prop
    },
    data() {
      return {
        fieldList: surveyService.getAnswer(this.question.id) || [],
        dropdownOptions: []
      };
    },
    methods: {
      addFieldSet() {
        const newFieldSet = {};
        this.question.fields.forEach(field => {
          newFieldSet[field.key_name] = "";
        });
        this.fieldList.push(newFieldSet);
        surveyService.setAnswer(this.question.id, this.fieldList); // Save the answer directly through the service
        this.$emit("input", this.fieldList);
      },
      removeFieldSet(index) {
        this.fieldList.splice(index, 1);
        surveyService.setAnswer(this.question.id, this.fieldList); // Save the answer directly through the service
        this.$emit("input", this.fieldList);
      },
      loadDropdownValues() {
        // Load dropdown values if selection-list exists
        this.question.fields?.forEach(field => {
          if (field.type === 'dropdown' && field['selection-list']) {
            const key = field['selection-list'].value;
            this.dropdownOptions = dropdownValues[key] || [];
          }
        });
      },
      initializeFieldList() {
        if (!this.fieldList.length) {
          this.addFieldSet();
        }
      }
    },
    watch: {
      question(newQuestion) {
        this.fieldList = surveyService.getAnswer(newQuestion.id) || [];
        this.loadDropdownValues();
        this.initializeFieldList(); // Ensure at least one field set is added
      }
    },
    mounted() {
      this.loadDropdownValues();
      this.initializeFieldList(); // Ensure at least one field set is added on initial load
    }
  };
  </script>

<style scoped>
/* Remove spinner arrows in number input (Chrome, Safari, Edge) */
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Remove spinner arrows in Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>